import { FaTimes, FaExternalLinkAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function ProductoModal({
  open,
  modoEdicion,
  producto,
  categorias,
  onChange,
  onClose,
  onSave,
}) {
  const navigate = useNavigate();

  if (!open) return null;

  const irACategorias = () => {
    onClose(); 
    navigate("/admin/categorias"); 
  };

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div
        className="bg-white dark:!bg-slate-900 rounded-2xl shadow-2xl
                   border border-slate-200 dark:border-slate-700
                   w-full max-w-md mx-4"
      >
        {/* Header */}
        <div
          className="flex items-center justify-between px-5 py-3
                     border-b border-slate-200 dark:border-slate-700
                     bg-slate-50 dark:!bg-slate-800"
        >
          <h3 className="text-sm sm:text-base font-semibold">
            {modoEdicion ? "✏️ Editar Producto" : "➕ Nuevo Producto"}
          </h3>

          <button
            onClick={onClose}
            className="p-1 rounded-full border border-slate-300 dark:border-slate-600
                       hover:bg-slate-200 dark:hover:bg-slate-700"
          >
            <FaTimes />
          </button>
        </div>

        {/* Body */}
        <div className="px-5 py-4 space-y-3">
          {/* Nombre */}
          <div>
            <label className="block text-xs font-medium mb-1">Nombre</label>
            <input
              value={producto.nombre}
              onChange={(e) => onChange("nombre", e.target.value)}
              className="w-full rounded-lg border px-3 py-2 text-sm"
            />
          </div>

          {/* Categoría */}
          <div>
            <label className="block text-xs font-medium mb-1">Categoría</label>
            <select
              value={producto.categoriaId}
              onChange={(e) => onChange("categoriaId", e.target.value)}
              className="w-full rounded-lg border px-3 py-2 text-sm"
            >
              <option value="">Seleccionar categoría</option>
              {categorias.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.nombre}
                </option>
              ))}
            </select>

            {/* 👉 BOTÓN NUEVO */}
            <button
              type="button"
              onClick={irACategorias}
              className="mt-2 text-xs text-sky-500 hover:underline
                         inline-flex items-center gap-1"
            >
              <FaExternalLinkAlt />
              Administrar categorías
            </button>
          </div>

          {/* Precio */}
          <div>
            <label className="block text-xs font-medium mb-1">Precio</label>
            <input
              type="number"
              value={producto.precio}
              onChange={(e) => onChange("precio", e.target.value)}
              className="w-full rounded-lg border px-3 py-2 text-sm"
            />
          </div>

          {/* Ingredientes */}
          <div>
            <label className="block text-xs font-medium mb-1">
              Ingredientes
            </label>
            <textarea
              value={producto.ingredientes}
              onChange={(e) => onChange("ingredientes", e.target.value)}
              className="w-full h-20 rounded-lg border px-3 py-2 text-sm"
            />
          </div>

          {/* Disponible */}
          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={!producto.bloqueado}
              onChange={(e) => onChange("bloqueado", !e.target.checked)}
            />
            <span className="text-sm">Disponible para la venta</span>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-2 px-5 py-3 border-t">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg border"
          >
            Cancelar
          </button>

          <button
            onClick={onSave}
            className="px-4 py-2 rounded-lg bg-emerald-500 text-white"
          >
            {modoEdicion ? "Guardar cambios" : "Registrar producto"}
          </button>
        </div>
      </div>
    </div>
  );
}
